export enum V2InstanceStatus {
  Completed = 'completed',
  Current = 'current',
  Overriden = 'overriden',
}
